import { SpreadsheetGrid } from "@components/spreadsheet/SpreadsheetGrid";
import { CellType } from "@components/spreadsheet/cells";
import type {
    ColumnDef,
    SpreadsheetRowData,
} from "@components/spreadsheet/types";
import styles from "../SpreadsheetPlayground.module.scss";

export const NESTED_HINT =
    "Expand a group with the chevron on the name column. Nested rows stay in the same grid.";

const COLUMNS: ColumnDef[] = [
    {
        field: "name",
        label: "Name",
        cellType: CellType.STRING,
    },
    {
        field: "owner",
        label: "Owner",
        cellType: CellType.STRING,
    },
];

export interface NestedRowsScenarioProps {
    data: SpreadsheetRowData[];
    expandedIds: string[];
    onExpandedChange: (expandedIds: string[]) => void;
}

export const NestedRowsScenario = ({
    data,
    expandedIds,
    onExpandedChange,
}: NestedRowsScenarioProps) => (
    <>
        <span>{NESTED_HINT}</span>
        <div className={styles.gridFrame}>
            <SpreadsheetGrid
                className={styles.grid}
                data={data}
                columns={COLUMNS}
                expandable
                defaultExpandedIds={expandedIds}
                onExpandedChange={onExpandedChange}
                enableColumnResizing={false}
                overflow="auto"
                gridTemplateColumns="minmax(240px, 1fr) 180px"
            />
        </div>
        <div className={styles.output}>
            <span>State</span>
            <pre role="status" aria-live="polite">
                {`Expanded: ${
                    expandedIds.length === 0 ? "None" : expandedIds.join(", ")
                }`}
            </pre>
        </div>
    </>
);
